import {
    StyleSheet
} from "react-native";
import type {
    HoverCardContentWidthConstantType,
    HoverCardContentDynamicStyleType
} from "./type";
import {
    getCornerStyle
} from "../../../../helpers/theme/corner";

export const HOVER_CARD_WIDTH_RATIO = 4 / 3;

export const getHoverCardContentWidth = ({
    shapeConfigs
}: HoverCardContentWidthConstantType): number => {
    return shapeConfigs.sideListWidth * HOVER_CARD_WIDTH_RATIO;
};

const stylesheet = StyleSheet.create({
    media: {
        justifyContent: "center",
        alignItems: "center",
        overflow: "hidden"
    },
    placeholderHead: {
        alignItems: "flex-start",
        flexDirection: "row"
    },
    content: {
        flexDirection: "column",
        minWidth: 0
    },
    placeholderText: {
        flexDirection: "column",
        flexShrink: 1,
        flexGrow: 1,
        minWidth: 0
    },
    placeholderStats: {
        flexDirection: "row"
    },
    sheetFooter: {
        flexDirection: "row"
    },
    hidden: {
        display: "none"
    },
    placeholderStat: {
        flexGrow: 1,
        flexBasis: 0
    }
});

export const useStyles = ({
    shapeConfigs,
    radiuses,
    borders,
    colors,
    spaces
}: HoverCardContentDynamicStyleType) => {
    const {
        borderRadius: mediaRadius,
        ...mediaShape
    } = getCornerStyle({
        radius: Math.max(radiuses.surface - borders.line, 0),
        shapeConfigs
    });

    const styles = {
        media: {
            backgroundColor: colors.content.container.subtle,
            aspectRatio: shapeConfigs.bannerRatio,
            marginHorizontal: -spaces.spacingMd,
            ...mediaShape,
            borderTopStartRadius: mediaRadius,
            borderTopEndRadius: mediaRadius,
            marginTop: -spaces.spacingMd
        },
        placeholderHead: {
            gap: spaces.spacingSm
        },
        placeholderStats: {
            gap: spaces.spacingSm
        },
        placeholderText: {
            gap: spaces.spacingXs
        },
        sheetFooter: {
            gap: spaces.spacingSm
        },
        content: {
            gap: spaces.spacingMd
        }
    };

    return styles;
};
export default stylesheet;
